import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import background from '../../background.png';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const faqs = [
  {
    question: 'What is a hackathon?',
    answer: 'A hackathon is a three-day event where participants come together to build innovative solutions to real-world problems.'
  },
  {
    question: 'Who can participate?',
    answer: 'The event is open to university students across the world, from any major. Students under 18 years old must get parent/guardian permission to attend.'
  },
  {
    question: 'What if I’ve never coded before?',
    answer: 'SanD Hacks welcomes anyone, we are beginner-friendly and there will be mentors and workshops to help you throughout the weekend.'
  },
  {
    question: 'Do I need to have a team?',
    answer: 'No, you do not need to have a team to participate in this event. We will have opportunities for you to meet fellow hackers and form your team at the hackathon, or an option to work individually as well.'
  },
  {
    question: 'Will there be prizes?',
    answer: 'Yes. More details will be released closer to the hackathon.'
  },
  {
    question: 'Is the event free?',
    answer: 'The event is free for all hackers. We will provide meals for the duration of the event, and the venue will be open for overnight stay. You must, however, make your own travel arrangements.'
  },
  // {
  //   question: 'How long will the event be?',
  //   answer: 'The event is expected to last 48 hours, with the opening ceremony starting Saturday 4 pm and the closing ceremony ending Sunday 4 pm.'
  // },
  {
    question: 'Where can I stay overnight?',
    answer: 'The hacking space will be open for overnight stay, and we will have a 24/7 snack table. Don’t forget to bring a sleeping bag!'
  },
  {
    question: 'What should I bring?',
    answer: 'Bring your laptop, charger, any hardware you want to use as well as personal items and toiletries for your stay. Don’t forget to bring your student ID. If you plan on staying overnight at the venue, a sleeping bag is recommended. We will provide you with meals and snacks!'
  },
];

const HeroSection = () => {
  return (
    <>
      {/* HERO SECTION */}
      <Box
    sx={{
      marginLeft: '2rem',
      marginRight: '2rem'
    }}
  >
      <Box
        sx={{
          minHeight: '100vh',
          backgroundImage: `url(${background})`,
          backgroundColor: '#030E5D',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right center',
          backgroundSize: 'contain',
          color: 'white',
          padding: { xs: '60px 20px', md: '100px 80px' },
          display: 'flex',
          flexDirection: 'column',
          textAlign: { xs: 'center', md: 'left' },
          alignItems: { xs: 'center', md: 'flex-start' },
        }}
      >
        {/* Title */}
        <Typography
          variant="h2"
          fontWeight={700}
          sx={{ fontSize: { xs: '2.5rem', md: '4rem' }, mb: 1 }}
        >
          SanD Hacks
        </Typography>

        {/* Year */}
        <Typography
          variant="h2"
          fontWeight={700}
          sx={{
            fontSize: { xs: '2.5rem', md: '4rem' },
            background: 'linear-gradient(to bottom, #FFFAEE, #EBB111)',
            fontFamily: 'Plus Jakarta Sans, sans-serif',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            textFillColor: 'transparent',
            mb: 1,
          }}
        >
          2026
        </Typography>

        {/* Date */}
        <Box
          sx={{
            backgroundColor: '#FFFFFF',
            color: '#1E1E1E',
            fontWeight: 600,
            fontSize: '1.4rem',
            fontFamily: 'Plus Jakarta Sans, sans-serif',
            paddingX: 2,
            paddingY: 1.5,
            borderRadius: '999px',
            display: 'inline-block',
            marginTop: 2,
            marginBottom: 10,
          }}
        >
          Jan 31 – Feb 1, 2026
        </Box>

        {/* Description */}
        <Typography
          variant="body1"
          sx={{
            maxWidth: '700px',
            fontSize: { xs: '1rem', md: '1.15rem' },
            fontFamily: 'Inter, sans-serif',
            lineHeight: 1.8,
            mb: 5,
          }}
        >
          SanD Hacks is the first hackathon hosted by UCSD's Computer Science & Engineering Society.
          Whether you're a seasoned coder or totally new to the field of computer science, join us for
          36 hours of building projects, making friends, and creating a community!
        </Typography>

        {/* CTA Button */}
        <Box
          component="a"
          href="https://forms.gle/5xLRmh7NAwYUZGnS9" 
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            textDecoration: 'none',
            background: 'linear-gradient(to right, #FDD446, #B2F1E8, #BCA2F8)',
            padding: '2px',
            borderRadius: '999px',
            display: 'inline-block',
          }}
        >
          <Box
            sx={{
              backgroundColor: '#030E5D',
              borderRadius: '999px',
              padding: '12px 40px',
            }}
          >
            <Typography
              sx={{
                color: 'white',
                fontWeight: 500,
                fontSize: '1.4rem',
                fontFamily: 'Inter, sans-serif',
              }}
            >
              Fill out the application form!
            </Typography>
          </Box>
        </Box>

        {/* Info Below Button */}
        <Typography
          variant="body2"
          sx={{
            maxWidth: '700px',
            fontSize: { xs: '1rem', md: '.9rem' },
            fontFamily: 'Inter, sans-serif',
            fontStyle: 'italic',
            lineHeight: 1.6,
            mt: 5,
            mb: 0,
            pb: 0,
          }}
        >
          Hacker applications opening soon. Sign up above to be the first to know when it happens.
          <br />
          <br />
          PS: We are also actively looking for judges and mentors. If interested, send an email to cses+hackathon@ucsd.edu
          with your resume/portfolio.
        </Typography>
      </Box>

     {/* SPONSOR SECTION */}
      <Box
        id="sponsor"
        sx={{
          width: '100vw',
          marginLeft: 'calc(-50vw + 50%)',
          background: 'linear-gradient(to right, #FDD446, #B2F1E8, #BCA2F8)', // outer gradient border
          padding: '2px',
          boxSizing: 'border-box',
          mt: { xs: '-170px', md: '-8px' },
          borderRadius: '8px', // keep border radius for the gradient border
        }}
      >
        {/* Solid background box with your requested color */}
        <Box
          sx={{
            backgroundColor: '#47518A', // solid 100% opacity color
            borderRadius: '6px',
            padding: { xs: 4, md: 6 },
            color: 'white', // set default text color here for convenience
          }}
        >

          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              fontSize: { xs: '1.6rem', md: '2rem' },
              fontFamily: 'Inter, sans-serif',
              mb: 5,
            }}
          >
            Interested in Sponsoring?
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: '1rem', md: '1.1rem' },
              fontFamily: 'Inter, sans-serif',
              whiteSpace: 'pre-line',
            }}
          >
            For over 21 years, CSES has been at the forefront of undergraduate computing, growing the largest student‑led tech community in San Diego. Support innovation at scale by sponsoring our hackathon. Gain direct access to top engineering talent through branding, tech talks,
            mentorship, and recruitment opportunities—both online and on-site.

            {'\n\n'}Check out our sponsorship package here and shoot us an email at {'\n'}cses+hackathon@ucsd.edu
          </Typography>
        </Box>
      </Box>
      {/* FAQ SECTION */}
<Box
  id="faq"
  sx={{
    backgroundColor: '#030E5D',
    color: 'white',
    padding: { xs: 4, md: 8 },
    textAlign: 'center',
  }}
>
  <Typography
    variant="h4"
    sx={{
      fontWeight: 700,
      fontSize: { xs: '2rem', md: '2.5rem' },
      mb: 4,
      fontFamily: 'Plus Jakarta Sans, sans-serif',
    }}
  >
    {'{FAQs}'}
  </Typography>

  {faqs.map((faq, index) => (
<Accordion
  key={index}
  disableGutters
  sx={{
    backgroundColor: 'white',
    color: '#000',
    borderRadius: '8px',
    mb: 2,
    boxShadow: '0px 2px 10px rgba(0,0,0,0.05)',
    '&:before': { display: 'none' },
    overflow: 'hidden',
  }}
>
      <AccordionSummary
        expandIcon={
          <ChevronRightIcon
            sx={{
              transition: 'transform 0.2s',
              color: 'black',
            }}
          />
        }
sx={{
  fontWeight: 600,
  fontSize: '1.1rem',
  px: 2,
  py: 1.5,
  fontFamily: 'Inter, sans-serif',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)', // turns > into v
  },
}}
      >
        {faq.question}
      </AccordionSummary>
      <AccordionDetails
  sx={{
    color: '#000',
    px: 2,
    pt: 0,
    pb: 4,
    fontSize: '1rem',
    fontFamily: 'Inter, sans-serif',
    textAlign: 'left',
  }}
>
        {faq.answer}
      </AccordionDetails>
    </Accordion>
  ))}
</Box>
</Box>
    </>
  );
};

export default HeroSection;
